app.component("searchToolbar", {
	templateUrl: "app/src/js/components/clinicLetter/search-toolbar.html",
	controller: "searchToolbarController",
	bindings: {
		patientId: '=',
		onRecipientChange: '&',
		preSelected: '=',
		careTeam: '='
	},
});

/**
 * item type
 * {
 *   type: EMAIL/EDI/PRACTICE_DIRECTORY/PRACTICE_ID
 *   name:
 *   obj:
 * }
 * 
 * 
 */

app.controller("searchToolbarController", [
	"$scope",
	"ClinicLettersAPI",
	"PracticeService",
	function ($scope,ClinicLettersAPI,PracticeService) {

		$scope.SearchAPI = ClinicLettersAPI;

		$scope.PracticeSearchAPI = PracticeService;

		$scope.searchText = '';
		$scope.selectedContacts = [];

		$scope.$watch(
			"$ctrl.preSelected",
			function (newValue, oldValue) {
				$scope.selectedContacts = [];
				if(newValue){
					newValue.forEach(element => {
						if(element.type === 'EMAIL'){
							$scope.selectedContacts.push({type:'EMAIL',name: element.name, obj: element.obj})
						}else if(element.type === 'EDI') {
							$scope.selectedContacts.push({type:'EDI',name: element.name, isInvalid: element.isInvalid})
						}else if(element.type === 'PRACTICE_DIRECTORY'){
							$scope.selectedContacts.push({type:'PRACTICE_DIRECTORY',name: element.name, obj: element.obj})
						}else if(element.type === 'PRACTICE_ID'){
							$scope.selectedContacts.push({type:'PRACTICE_ID',name: element.name, obj: element.obj})
						}
						
					});
				}
			},
			true
		);

		$scope.fetchOrg = function (value) {
			$scope.org_loading = true;
			return new Promise((resolve, reject) => {
				searchOrg(value, resolve, reject)
			})
		}

		function searchOrg(terms, resolve, reject) {
			$scope.resultOrg = [];
			$scope.noResultsOrg = false;

			const practice = $scope.$ctrl.careTeam.filter(a=>a.patient_care_team_member_type === 'CATTRAX_PRACTICE' && a.practice_name.toLowerCase().includes(terms.toLowerCase() ));
			const user = $scope.$ctrl.careTeam.filter(a=>a.patient_care_team_member_type === 'CATTRAX_USER' && a.user_full_name.toLowerCase().includes(terms.toLowerCase() )).map(m=>({...m,practice_name:m.user_full_name}))


			const careResult = [...practice,...user];

			Promise.all([
				$scope.SearchAPI.searchPracticeDirectory(terms), 
				$scope.SearchAPI.queryCatraxUsersByTerm(terms),
				$scope.PracticeSearchAPI.searchPractices(terms)
			]).then(
				function (results) {
					$scope.resultOrg = [];
					if(results[0].data){
						$scope.resultOrg = [...results[0].data];
					}

					if (results[1].data) {
						$scope.resultOrg = [
							...$scope.resultOrg,
							...results[1].data.map((m) => ({
								...m,
								search_type: "CATTRAX_USER",
								practice_name: `${m.title} ${m.firstName} ${m.lastName} (${m.practiceName})`,
							})),
						];
					}

					if (results[2].data) {
						$scope.resultOrg = [
							...$scope.resultOrg,
							...results[2].data.map((m) => ({
								...m,
								practice_name: `${m.name}`,
								practice_id: m.id,
							})),
						];
					}
					
					$scope.resultOrg = [...$scope.resultOrg,...careResult];
					resolve($scope.resultOrg)
				},
				function (error) {
					$scope.noResultsOrg = true;
					$scope.resultOrg = careResult;
					resolve($scope.resultOrg);
				}
			);

			// $scope.SearchAPI.searchPracticeDirectory(terms)
			// 	.then(
			// 		function (resp) {
			// 			if(resp.data){
			// 				const result = resp.data;
			// 				$scope.resultOrg = result;
			// 			}
						
			// 			$scope.resultOrg = [...$scope.resultOrg,...careResult];
			// 			resolve($scope.resultOrg)
			// 		},
			// 		function (error) {
			// 			$scope.noResultsOrg = true;
			// 			$scope.resultOrg = careResult;
			// 			resolve($scope.resultOrg)
			// 		}
			// 	)
		}

		$scope.formatOrgName = function (item) {
			if (!item) return '';
    
			// If region exists, append it. Otherwise, just return the practice name.
			if (item.region) {
				return `${item.practice_name} (${item.region})`;
			}
			
			return item.practice_name;
		}

		$scope.orgOnSelect = function (item, model, label, event) {
			if (item.practice_directory_id) {
				$scope.selectedContacts.push({ type: "PRACTICE_DIRECTORY", name: `${item.practice_name}${item.region ? ` (${item.region})` : ""}`, obj: item });
			} else if (item.patient_care_team_member_type === "CATTRAX_USER") {
				$scope.selectedContacts.push({ type: "EMAIL", name: item.practice_name, obj: item.patient_care_team_contact_info.EMAIL });
			} else if (item.search_type === "CATTRAX_USER") {
				$scope.selectedContacts.push({ type: "EMAIL", name: item.practice_name, obj: item.email});
			} else {
				$scope.selectedContacts.push({ type: "PRACTICE_ID", name: item.practice_name, obj: item });
			}
			$scope.searchText = "";
			$scope.$ctrl.onRecipientChange({recipients:$scope.selectedContacts})
		};
		$scope.searchText = "";

		$scope.selectedContacts = [];

		$scope.removeContact = function (index) {
			$scope.selectedContacts.splice(index, 1);
			$scope.$ctrl.onRecipientChange({ recipients: $scope.selectedContacts });
		};

		  function isEmail (str) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailRegex.test(str);
		  };

		  function isEDI (str) {
			// Anchored: the whole entry must be an EDI, not merely contain a word shaped like one.
			const regex = /^[a-z][a-z0-9]{5,9}$/;
			return regex.test(str);
		  }
		
		  // The input is debounced, so a blur or Enter straight after typing would read a stale
		  // searchText. Commit the pending view value first.
		  function commitPendingInput(event) {
				const ngModel = event && event.target && angular.element(event.target).controller("ngModel");
				if (ngModel) {
					ngModel.$commitViewValue();
				}
		  }

		  $scope.hideSuggestions = function (event) {
				commitPendingInput(event);
				setTimeout(() => {
					if (!$scope.searchText) {
						return;
					} else if ($scope.selectedContacts.some((t) => t.name === $scope.searchText)) {
						$scope.searchText = "";
						return;
					} else if (isEmail($scope.searchText)) {
						$scope.selectedContacts.push({ name: $scope.searchText, type: "EMAIL" });
					} else if (isEDI($scope.searchText)) {
						$scope.selectedContacts.push({ name: $scope.searchText, type: "EDI" });
					} else {
						$scope.selectedContacts.push({ name: $scope.searchText, type: "EDI", isInvalid: true });
					}
					
					$scope.searchText = "";
					$scope.$apply();
					$scope.$ctrl.onRecipientChange({recipients:$scope.selectedContacts})
				}, 200);
			};

			$scope.handleEnter = function(event) {
				if (event.keyCode === 13) { // 13 is the keyCode for the Enter key
					$scope.hideSuggestions(event);
					event.preventDefault();
					event.stopPropagation();
				}
				
			};
    }])